'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Address = function (_React$Component) {
    _inherits(Address, _React$Component);

    function Address(props) {
        _classCallCheck(this, Address);

        var _this = _possibleConstructorReturn(this, (Address.__proto__ || Object.getPrototypeOf(Address)).call(this, props));

        _this.handleInput = function (e) {
            // this is where we'll call the phoneNumberFormatter function
            var formattedPhoneNumber = Utils.convertStringToPhoneNumberFormat(e.target.value);

            _this.setState({
                phoneNumber: formattedPhoneNumber,
                error: ''
            });
        };

        _this.state = _this.initialState();
        _this.fillInAddress = _this.fillInAddress.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.autocomplete = null;
        return _this;
    }

    _createClass(Address, [{
        key: 'initialState',
        value: function initialState() {
            return {
                name: '',
                phoneNumber: '',
                addLine1: '',
                addLine2: '',
                city: '',
                state: '',
                zipCode: '',
                country: '',
                buttonText: 'Save Address',
                error: '',
                isAddressBeingAdd: false
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            var activeLocation = _MainStore2.default.getActiveLocation();
            var defaultCountry = activeLocation.country ? activeLocation.country : "US";

            // Initialized the AutoComplete
            this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
                componentRestrictions: { country: [defaultCountry] },
                fields: ["address_components", "geometry"],
                types: ["address"]
            });

            this.autocomplete.addListener("place_changed", this.fillInAddress);

            $('#' + this.props.modalId).on("scroll", function () {

                var isVisible = $('.pac-container').is(':visible');
                if (isVisible) {
                    $('.pac-container').hide();
                }
            });

            // set the default user name and phone number
            var currentUser = _parse2.default.User.current();
            var userName = currentUser.get('name');
            var phoneNumber = currentUser.get("phoneNumber") ? currentUser.get("phoneNumber") : "";
            var phoneNo = Utils.formatPhoneNumber(phoneNumber);

            this.setState({
                name: userName,
                phoneNumber: phoneNo
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            var _setState;

            this.setState((_setState = {}, _defineProperty(_setState, event.target.name, event.target.value), _defineProperty(_setState, 'error', ''), _setState));
        }
    }, {
        key: 'fillInAddress',
        value: function fillInAddress() {

            this.setState({ error: '' });

            // Get the place details from the autocomplete object.
            var place = this.autocomplete.getPlace();

            var address1 = "";
            var postcode = "";
            var locality = "";
            var state = "";
            var country = "";

            //If we can find the place lets go to it
            if (typeof place.address_components !== 'undefined') {
                // Get each component of the address from the place details,
                // and then fill-in the corresponding field on the form.
                // place.address_components are google.maps.GeocoderAddressComponent objects
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = place.address_components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var component = _step.value;

                        var componentType = component.types[0];

                        switch (componentType) {
                            case "street_number":
                                {
                                    address1 = component.long_name + ' ' + address1;
                                    break;
                                }
                            case "route":
                                {
                                    address1 += component.short_name;
                                    break;
                                }
                            case "postal_code":
                                {
                                    postcode = '' + component.long_name + postcode;
                                    break;
                                }
                            // case "postal_code_suffix": {
                            //     postcode = `${postcode}-${component.long_name}`;
                            //     break;
                            // }
                            case "locality":
                                locality = component.long_name;
                                break;
                            case "administrative_area_level_1":
                                {
                                    state = component.short_name;
                                    break;
                                }
                            case "country":
                                country = component.short_name;
                                break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var addressField = document.getElementById('autocomplete');
                addressField.value = address1 + ", " + locality + ", " + state + ", " + postcode + ", " + country;

                this.setState({
                    addLine1: address1,
                    city: locality,
                    state: state,
                    zipCode: postcode,
                    country: country
                });
            } else {
                this.setState({
                    addLine1: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    country: ""
                });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            var _this2 = this;

            event.preventDefault();

            var sname = this.state.name.replaceAll(/\s+/g, ' ').trim();

            // validation
            if (Utils.isEmpty(sname)) {
                this.setState({ error: 'User name is empty.' });
                return;
            }
            // validation
            if (Utils.isEmpty(this.state.phoneNumber)) {
                this.setState({ error: 'Phone number is empty.' });
                return;
            }

            var phoneNo = Utils.removeNonNumber(this.state.phoneNumber);
            // validation
            if (phoneNo.length !== 10) {
                this.setState({ error: 'Phone number must be of 10 Digits.' });
                return;
            }
            // validation
            if (Utils.isEmpty(this.state.addLine1)) {
                this.setState({ error: 'Address is empty.' });
                return;
            }

            this.setState({ isAddressBeingAdd: true });

            var formData = {
                name: sname,
                addLine1: this.state.addLine1,
                addLine2: this.state.addLine2,
                city: this.state.city,
                state: this.state.state,
                zipCode: this.state.zipCode,
                country: this.state.country,
                phoneNumber: phoneNo
            };

            var currentUser = _parse2.default.User.current();
            currentUser.addUnique("deliveryAddress", formData);
            currentUser.save().then(function (user) {
                _this2.setState({
                    name: '',
                    addLine1: '',
                    addLine2: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    phoneNumber: '',
                    country: '',
                    isAddressBeingAdd: false
                });
                _this2.props.onAddressSubmit(formData);
            }, function (error) {
                Utils.checkErrorIsInvalidSessionToken(error, '/', false);
                _this2.setState({
                    isAddressBeingAdd: false,
                    error: error.message,
                    buttonText: error.message
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                null,
                !Utils.isEmpty(this.state.error) ? _react2.default.createElement(
                    'div',
                    { className: 'alert alert-danger', role: 'alert' },
                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Error:'
                    ),
                    this.state.error
                ) : null,
                _react2.default.createElement(
                    'form',
                    { className: 'form-horizontal', onSubmit: this.handleSubmit },
                    _react2.default.createElement(
                        'fieldset',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'form-group-label' },
                                    'Name'
                                ),
                                _react2.default.createElement('input', {
                                    // tabIndex={0}
                                    type: 'text',
                                    placeholder: 'Name',
                                    onChange: this.handleChange,
                                    name: 'name',
                                    value: this.state.name,
                                    className: 'form-control',
                                    title: 'Numbers & Special Characters not Allowed like (@ * . # ! $ ^ &)',
                                    pattern: '[ a-zA-Z][ a-zA-Z ]+[ a-zA-Z]$'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6 state-zip-margin' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'form-group-label' },
                                    'Phone Number'
                                ),
                                _react2.default.createElement('input', {
                                    // tabIndex={1}
                                    type: 'tel',
                                    placeholder: 'Phone Number',
                                    title: 'Phone Number',
                                    onChange: function onChange(e) {
                                        return _this3.handleInput(e);
                                    },
                                    name: 'phoneNumber',
                                    value: this.state.phoneNumber,
                                    className: 'form-control',
                                    required: true
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'form-group-label' },
                                    'Search the address on Google'
                                ),
                                _react2.default.createElement('input', {
                                    // tabIndex={2}
                                    id: 'autocomplete',
                                    className: 'input-field form-control',
                                    ref: 'input',
                                    type: 'text',
                                    placeholder: "Start typing to search address on Google"
                                    // autocomplete="no"
                                })
                            )
                        ),
                        this.state.addLine1 ? _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'form-group-label' },
                                    'Apartment, unit, suite, or floor (Optional)'
                                ),
                                _react2.default.createElement('input', {
                                    // tabIndex={3}
                                    type: 'text',
                                    placeholder: 'Apartment, unit, suite, or floor',
                                    title: 'Apartment, unit, suite, or floor',
                                    onChange: this.handleChange,
                                    name: 'addLine2',
                                    value: this.state.addLine2,
                                    className: 'form-control'
                                })
                            )
                        ) : null,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(_SpinButton2.default
                                // tabIndex={4}
                                , { classNames: 'themebtn btn-block btn-styl',
                                    buttonText: this.state.buttonText,
                                    spinText: "Saving address...",
                                    showSpinner: this.state.isAddressBeingAdd,
                                    inputType: 'submit'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Address;
}(_react2.default.Component);

exports.default = Address;


//////////////////
// WEBPACK FOOTER
// ./src/components/account/Address.jsx
// module id = 492
// module chunks = 0